import { isArray, isNumber } from 'lodash'
import { SOURCE_FILE_TYPES } from '~/enums'
import * as Selectors from '~/selectors'
import * as API from '~/ServerAPI'
import { createMediaFile, startBatchFileUploadTask } from './sourceFiles'
import { selectMenuItem, selectBehaviourSettings } from '~/selectors/mainView'
import { BehaviourSettings } from '~/config/constants/editorSettings'

export const importLocalFile = file => async (dispatch, getState) => {
  let response = null
  const state = getState()
  const menuItem = selectMenuItem(state)
  const settings = selectBehaviourSettings(state)
  const useDialogBox = settings[BehaviourSettings.useModalDialogForImportLocalFiles]
  const isBatchUpload = useDialogBox && isArray(file)
  try {
    const folderId = Selectors.selectCurrentFolderId(getState(), SOURCE_FILE_TYPES.MEDIA)
    if (isBatchUpload) {
      const [ paths, sizes ] = file.reduce((result, data) => {
        const { path, size } = data
        if (path) result[0].push(path)
        if (isNumber(size)) result[1].push(size)
        return result
      }, [[], []])

      response = await API.importFromLocalFilesBatch(paths, sizes, folderId)
    } else {
      response = await API.importFromLocalFile(file.path, file.size, folderId)
    }
  } catch (err) {
    response = err.response
  }
  const { id } = response?.data ?? {}
  const mediaPool = menuItem === SOURCE_FILE_TYPES.PROJECT_MEDIA
    ? menuItem
    : SOURCE_FILE_TYPES.MEDIA
  if (id !== undefined) {
    if (isBatchUpload) {
      await dispatch(startBatchFileUploadTask(id, mediaPool))
    } else {
      await dispatch(createMediaFile(id, undefined, mediaPool))
    }
  }
}
